/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab200,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab500,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabQueryResponse,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab.ts";
import { courseRegistrationManagementPoloHistoryItemViewModelSchema } from "../courseRegistrationManagementPoloHistoryItemViewModelSchema.ts";

export const getApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab200Schema =
  z.array(
    z.lazy(() => courseRegistrationManagementPoloHistoryItemViewModelSchema),
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab400Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab500>;

export const getApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabQueryResponse>;
